import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccessCodeEffects } from '@shared/store/effects/access-code';
import { AccountStatusEffects } from '@shared/store/effects/account-status';
import { AuthEffects } from '@shared/store/effects/auth';
import { CalendarEffects } from '@shared/store/effects/calendar';
import { ConfigEffects } from '@shared/store/effects/config';
import { ContactEffects } from '@shared/store/effects/contact';
import { ContractEffects } from '@shared/store/effects/contract';
import { FaqEffects } from '@shared/store/effects/faq';
import { FireServicesEffects } from '@shared/store/effects/fire-services';
import { LayoutEffects } from '@shared/store/effects/layout';
import { LoginAuthEffects } from '@shared/store/effects/login-auth';
import { MetadataEffects } from '@shared/store/effects/metadata';
import { MonerisEffects } from '@shared/store/effects/moneris';
import { NetworkStatusEffects } from '@shared/store/effects/network-status';
import { OobAuthEffects } from '@shared/store/effects/oob-auth';
import { OrganizationEffects } from '@shared/store/effects/organization';
import { ParksEffects } from '@shared/store/effects/parks';
import { PasswordAuthEffects } from '@shared/store/effects/password-auth';
import { PpaEffects } from '@shared/store/effects/ppa';
import { ProfileEffects } from '@shared/store/effects/profile';
import { RedirectEffects } from '@shared/store/effects/redirect';
import { RegisterContractEffects } from '@shared/store/effects/register-contract';
import { RegisterEmailAuthEffects } from '@shared/store/effects/register-email-auth';
import { RegisterEmailPendingAuthEffects } from '@shared/store/effects/register-email-pending-auth';
import { RegisterESubscriptionEffects } from '@shared/store/effects/register-subscription';
import { ScopeEffects } from '@shared/store/effects/scope';
import { SectorsEffects } from '@shared/store/effects/sectors';
import { ServicesEffects } from '@shared/store/effects/services';
import { SessionEffects } from '@shared/store/effects/session';
import { SettingsEffects } from '@shared/store/effects/settings';
import { SplashEffects } from '@shared/store/effects/splash';
import { SubscriptionEffects } from '@shared/store/effects/subscription';
import { SubscriptionEditEffects } from '@shared/store/effects/subscription-edit';
import { UserEffects } from '@shared/store/effects/user';
import { UserSessionEffects } from '@shared/store/effects/user-session';
import { UserVehiclesEffects } from '@shared/store/effects/user-vehicles';
import { VehiclesEffects } from '@shared/store/effects/vehicles';
import { WindowEffects } from '@shared/store/effects/window';
import { EffectsModule as NgrxEffectsModule } from '@ngrx/effects';

@NgModule({
	imports: [
		CommonModule,
		NgrxEffectsModule.forRoot([
			SectorsEffects,
			CalendarEffects,
			FireServicesEffects,
			SessionEffects,
			AuthEffects,
			LoginAuthEffects,
			RedirectEffects,
			PasswordAuthEffects,
			OobAuthEffects,
			RegisterEmailAuthEffects,
			MetadataEffects,
			RegisterEmailPendingAuthEffects,
			RegisterESubscriptionEffects,
			UserSessionEffects,
			UserEffects,
			RegisterContractEffects,
			SubscriptionEditEffects,
			UserVehiclesEffects,
			VehiclesEffects,
			AccountStatusEffects,
			FaqEffects,
			ConfigEffects,
			LayoutEffects,
			ScopeEffects,
			ProfileEffects,
			SubscriptionEffects,
			ParksEffects,
			OrganizationEffects,
			SettingsEffects,
			SplashEffects,
			ServicesEffects,
			ContractEffects,
			AccessCodeEffects,
			NetworkStatusEffects,
			WindowEffects,
			PpaEffects,
			MonerisEffects,
			ContactEffects
		])
	],
	providers: [],
	declarations: []
})
export class EffectsModule {}
